import { backendApi } from '@app/services'

import { FetchTranslationsResponse } from './types'

export const fetchTranslations = async (lang: string) => {
  const { data } = await backendApi.get<FetchTranslationsResponse>(
    `/translations/${lang}`
  )
  return data
}
